import client from './client';

export const shippingRatesApi = {
  getActive() {
    return client.get('/shipping-rates/active');
  },
  updateActive(data) {
    return client.patch('/shipping-rates/active', data);
  },
};

